// removed by extract-text-webpack-plugin
module.exports = {"studentData":"studentData_TxR5R","i_bar":"i_bar_3rsv3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/container/profile/style.css
 ** module id = 950
 ** module chunks = 0
 **/